<div class="group-buttons-lang">
    <button type="button" (click)="setLanguage(lang)" class="btn-lang" *ngFor="let lang of languages"
        [ngClass]="{'lang-actived' : currentLanguage.Key === lang.Key}">
        <span ngClass="flag-icon flag-icon-{{lang.FlagIcon}}"></span>
    </button>
</div>